<div class="container" *ngIf="foods.length">
  <ul class="product-list present row">
    <li
      *ngFor="let item of foods; let i = index"
      class="col-6 col-md-4"
      [ngClass]="{ 'product-active': item.id == selectedFood?.id }"
    >
      <label for="food-{{ i }}">
        <img class="img-fluid" vtMedia [object]="item.picture" />
        <a
          *ngIf="item.PDFPath"
          href="javascript:void(0);"
          class="btn btn-primary btn-link"
          showPDF
          [PDFPath]="item.PDFPath"
        >
          {{ 'pdfIsHere' | i18n }}
        </a>
        <div class="product-title">
          {{ item.name }}
        </div>
      </label>
      <div class="choice" *ngIf="showSelectionCheckbox">
        <RadioButton
          id="food-{{ i }}"
          name="food"
          [value]="item.id"
          [checked]="item.id == selectedFood?.id"
          (change)="onSelectionChange(item)"
        ></RadioButton>
      </div>
    </li>
  </ul>
</div>
